import src from "IMAGE";
export default { src, width: 1528, height: 263, blurWidth: 0, blurHeight: 0};
